<template>
  <div class="workes">
    <ul>
      <li v-for="item in items">
        <div class="user-info">
          <div class="img-ui">
            <img :src="item.headImage | avatarAdvi(120, 120)" />
          </div>
          <div class="user-summary">
            <div class="name">
              {{ item.workerName }}
            </div>
            <p>{{ item.storeName }}</p>
          </div>
        </div>
        <div class="to-img" @click="toIm(item)">
          <i></i>
          <p>联系她</p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    async toIm(workerInfo) {
      await this.$$ensureLogin()
      const baseHref = `http://a.app.qq.com/o/simple.jsp?pkgname=com.kidswant.ss&cmd=usercard&userid=${workerInfo.uid}`
      if (this.$$isHZWApp() || this.$$isRkhy()) {
        if (workerInfo.userType === 1) {
          window.location = `//im.cekid.com/shequ/chat/?targetId=${workerInfo.uid} &cmd=imconversation&scenetype=11&userid=${workerInfo.uid}&refresh=no`
        } else {
          window.location.href = baseHref
        }
      } else {
        window.location.href = baseHref
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.workes {
  margin-bottom: rem(24px);

  ul {
    margin-top: -1px;
    background-color: #fff;
    padding: rem(24px);
    border-bottom-left-radius: rem(16px);
    border-bottom-right-radius: rem(16px);
    li {
      @include border(bottom);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: rem(32px) 0;
      &:last-child {
        @include border(bottom, #fff, 0);
      }
      .img-ui {
        width: rem(120px);
        height: rem(120px);
        overflow: hidden;
        border-radius: 100%;
        flex: none;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .user-info {
        flex: auto;
        display: flex;
        align-items: center;
        overflow: hidden;
        .user-summary {
          padding-left: rem(20px);
          flex: auto;
          overflow: hidden;

          .name {
            line-height: rem(40px);
            font-size: rem(32px);
            color: #333333;
            @include ellicpsis;
          }
          p {
            padding-top: rem(16px);
            font-size: rem(24px);
            color: #666666;
            line-height: rem(24px);
            @include ellicpsis;
          }
        }
      }
      .to-img {
        display: flex;
        align-items: center;
        flex-direction: column;
        flex: none;
        margin-left: rem(10px);
        i {
          display: block;
          width: rem(46px);
          height: rem(52px);
          background: url('~@/assets/images/icon-im_pp@3x.png') no-repeat center;
          background-size: rem(46px) auto;
        }
        p {
          font-size: rem(26px);
          color: #ff397e;
          text-align: center;
          line-height: rem(32px);
          padding-top: rem(6px);
        }
      }
    }
  }
}
</style>
